export const getMultiSelectFilterValues = (e) => {
    let newValues = [];
    if (e.length > 0) {
        for (let i = 0; i < e.length; i++) {
            newValues.push(e[i].id);
        }
    }
    return newValues;
};

export const getColumnFilterMultiSelectValues = (sourceIds, columnFiltersValues) => {
    let results = [];

    if (!sourceIds || sourceIds.length === 0) return [];

    if (columnFiltersValues && columnFiltersValues.length > 0) {
        for (let i = 0; i < sourceIds.length; i++) {
            const value = columnFiltersValues.find((m) => m.id.toString() === sourceIds[i].toString());
            if (value) {
                results.push(value);
            }
        }
    }

    return results;
};

export function getOnActiveChangeValue(e) {
    if (e.value && typeof e.value === 'object' && 'value' in e.value) {
        return e.value.value;
    } else {
        return e.value;
    }
}